'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CarHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultClasses = require('../../../../../constants/defaultClasses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarHeader(props) {
  var text = props.text,
      components = props.components;


  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'CarHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CarOptionContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'span',
            { style: (0, _defaultClasses.containerClass)(components.CarOptionLabel) },
            text
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Passive/CarHeader.jsx
// module id = 1503
// module chunks = 0